module.exports = __webpack_public_path__ + "img/wedding-10.4d79f3db.jpg";